export default __webpack_public_path__ + "static/car_vertical-eee35f419c1a019ed103f2e9080a99d3.png";